import Shipment from '../../../types/api/shipment'

export function isShipmentStarted(shipment?: Shipment | null): boolean {
    return Boolean(shipment?.executedAt)
}
